<ng-template #templateRef>
  <mat-dialog-content>
    <mat-horizontal-stepper #stepper [linear]="true">
      <mat-step [stepControl]="relationForm" errorMessage="Fill in the required fields" label="Relation">
        <form #relationForm="ngForm">
          <div class="row">
            <div class="col-12">
              <app-relation-selector [(ngModel)]="Base.Relation" name="Relation"></app-relation-selector>
            </div>
          </div>
        </form>
      </mat-step>
      <mat-step label="Excel file">
        <div class="row">
          <div class="col-12">
            <p>Please follow the next steps carefully.</p>
            <ol>
              <li>Download the excel <a download="template.xlsx" href="./assets/template.xlsx" target="_blank">template here.</a></li>
              <li>Complete the excel. <strong>Important: The tab should match exactly the name "Import"</strong>.</li>
              <li>Upload the excel with the button below and click on "next".</li>
            </ol>
            <p></p>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <form>
              <input (change)="readFile($event);" name="file" type="file">
            </form>
          </div>
        </div>
      </mat-step>
      <mat-step errorMessage="Fill in the required fields" label="Validate">
        <div *ngIf="numErrors() > 0" class="row">
          <div class="col-12">
            <p (click)="showOnlyErrors = !showOnlyErrors" class="p-3 w-100 bg-warning msgbox">
              Of the {{List.length}} addresses in your upload, {{numReady()}} have been created succesfully and <strong>{{numErrors()}} has not been created</strong> due to an error.
              To make it easier I'll only show the addresses with errors below. Click here to switch.
            </p>
          </div>
        </div>
        <div class="row ">
          <div class="col-12" style="overflow:scroll;">
            <table class="mat-mdc-table">
              <tr>
                <th>Type</th>
                <th>Name</th>
                <th>Email</th>
                <th>Street</th>
                <th>Number</th>
                <th>Postcode</th>
                <th>City</th>
                <th>Country</th>
                <th>ShippingInfo</th>
                <th>CarrierServiceLevel</th>
                <th>CarrierServiceLevelOther</th>
                <th>SupplyPlant</th>
                <th>Remarks</th>
                <th>Imported</th>
                <th>Actions</th>
              </tr>
              <ng-container *ngFor="let row of List">
                <tr *ngIf="!showOnlyErrors || (showOnlyErrors && row.error)">
                  <td>{{row.obj.Type?.Value}}</td>
                  <td>{{row.obj.Name}}</td>
                  <td>{{row.obj.Email}}</td>
                  <td>{{row.obj.Street}}</td>
                  <td>{{row.obj.Number}}</td>
                  <td>{{row.obj.Postcode}}</td>
                  <td>{{row.obj.City}}</td>
                  <td>{{row.obj.Country?.Name}}</td>
                  <td>{{row.obj.ShippingInfo}}</td>
                  <td>{{row.obj?.CarrierServiceLevel?.Value}}</td>
                  <td>{{row.obj?.CarrierServiceLevelOther?.Value}}</td>
                  <td>{{row.obj?.SupplyPlant?.Value}}</td>
                  <td>{{row.obj.Remarks}}</td>
                  <td>
                    <mat-icon>{{row.imported ? 'check' : 'clear'}}</mat-icon>
                  </td>
                  <td>
                    <mat-icon *ngIf="row.error" [matTooltip]="row.error">warning</mat-icon>
                    <ng-container *ngIf="row.loading">
                      <mat-spinner class="spinner" color="accent" diameter="18"></mat-spinner>
                    </ng-container>
                    <button (click)="aEditor.edit(row.obj)" *ngIf="!row.imported" [disabled]="row.loading" mat-icon-button matTooltip="Edit">
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button (confirm)="removeRow(row)" appConfirmDialog mat-icon-button matTooltip="Delete">
                      <mat-icon>delete</mat-icon>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </table>
          </div>
        </div>
      </mat-step>
      <mat-step label="Import">

        <div *ngIf="numErrors() > 0" class="row">
          <div class="col-12">
            <p class="p-3 w-100 bg-warning msgbox">
              Aww, there were {{numErrors()}} errors. <strong>Please go back and fix the errors, and try again.</strong>
            </p>
          </div>
        </div>

        <div *ngIf="numTogo() === 0" class="row">
          <div class="col-12">
            <p class="p-3 w-100 bg-success msgbox">
              Wooof!! All the {{this.List.length}} addresses <strong>have been imported, paw!</strong>
            </p>
          </div>
        </div>

        <div *ngIf="!isLoading()" class="row">
          <div class="col-12 pb-4">
            <p>Click on "Import" to start importing.</p>
            <mat-progress-bar [value]="getProgression()" mode="determinate"></mat-progress-bar>
          </div>
        </div>

        <div *ngIf="isLoading()" class="row">
          <div class="col-12 pb-4">
            <p>Please be patient, I am working. <strong>There are currently {{numReady()}} of {{this.List.length}} addresses imported</strong>.</p>
            <mat-progress-bar [value]="getProgression()" mode="determinate"></mat-progress-bar>
          </div>
        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </mat-dialog-content>

  <mat-dialog-actions>
    <ng-container [ngSwitch]="stepper.selectedIndex">
      <ng-container *ngSwitchCase="3">
        <button (click)="stepper.previous()" class="float-left" mat-button type="button">Back</button>
        <div class="fill-remaining-space"></div>
        <button (click)="import()" [disabled]="isLoading() || numTogo() === 0" class="float-right" mat-button type="button">{{numErrors() > 0 ? 'Re-try to import' : 'Import'}}</button>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <button (click)="stepper.previous()" mat-button type="button">Back</button>
        <div class="fill-remaining-space"></div>
        <button (click)="stepper.next()" mat-button type="button">Next</button>
      </ng-container>
    </ng-container>
  </mat-dialog-actions>

  <app-crm-address-editor #aEditor [localOnly]="true"></app-crm-address-editor>

</ng-template>
